/* The composer builds from this exact path (src/client.jsx), so it stays .jsx
/* and only hands off to the typed entry. */
import { startClient } from './entry-client';

startClient();
